// extracted by mini-css-extract-plugin
export default {"container":"Maincarousel_container__Vjmb7","item":"Maincarousel_item__7RMPq","img":"Maincarousel_img__RkFrK"};